module.exports = "/_next/static/images/models-br-7c0ccae6b977f58337d0fec99d5a95b4.jpg";